export enum Teams {
  'Cruel Pumas' = 'Cruel Pumas',
  'Shining Angels' = 'Shining Angels',
  'Mystic Unicorns' = 'Mystic Unicorns',
  'River City' = 'River City',
  'Zenonia Knights' = 'Zenonia Knights',
  'Forest Elves' = 'Forest Elves',
}

export enum PlayerTypes {
  INT = 'INT',
  STR = 'STR',
  MNT = 'MNT',
  DEX = 'DEX',
}

type Player = {
  team?: Teams | 'any';
  type?: PlayerTypes;
};

export enum InfieldPositions {
  'C' = 'C',
  '1B' = '1B',
  '2B' = '2B',
  '3B' = '3B',
  'SS' = 'SS',
}

export enum OutfieldPositions {
  'LF' = 'LF',
  'CF' = 'CF',
  'RF' = 'RF',
}

export type BatterPositions = InfieldPositions | OutfieldPositions;

export type IBatter = Player & {
  positionType: 'batter' | 'any';
  position: BatterPositions | 'any';
};

export enum PitcherPositions {
  'SP' = 'SP',
  'RP' = 'RP',
  'CP' = 'CP',
}

export type Positions = BatterPositions | PitcherPositions;

export type IPitcher = Player & {
  positionType: 'pitcher' | 'any';
  position: PitcherPositions | 'any';
};

export type IPlayer = IBatter | IPitcher;

export const AllPositions = [
  ...Object.keys(InfieldPositions),
  ...Object.keys(PitcherPositions),
  ...Object.keys(OutfieldPositions),
];
